Object.defineProperty(exports, "__esModule", { value: true });
exports.inferTypeByTarget = exports.parseNativeTypeToGraphQL = exports.isParsableScalar = void 0;
require("reflect-metadata");
const graphql_1 = require("graphql");
const graphql_iso_date_1 = require("graphql-iso-date");
function isParsableScalar(input) {
    return [String, Number, Boolean, Date].includes(input);
}
exports.isParsableScalar = isParsableScalar;
function parseNativeTypeToGraphQL(input) {
    switch (input) {
        case String:
            return graphql_1.GraphQLString;
        case Number:
            return graphql_1.GraphQLFloat;
        case Boolean:
            return graphql_1.GraphQLBoolean;
        case Date:
            return graphql_iso_date_1.GraphQLDateTime;
    }
}
exports.parseNativeTypeToGraphQL = parseNativeTypeToGraphQL;
function inferTypeByTarget(target, key) {
    if (!key) {
        return Reflect.getMetadata('design:type', target);
    }
    const returnType = Reflect.getMetadata('design:returntype', target, key);
    if (returnType) {
        return returnType;
    }
    return Reflect.getMetadata('design:type', target, key);
}
exports.inferTypeByTarget = inferTypeByTarget;
//# sourceMappingURL=parseNative.js.map